import { Button, Grid, TextField, Typography } from "@mui/material";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { FieldError, UseFormMethods } from "react-hook-form";
import { Loader } from "@common/Loader/Loader";

interface IParams {
    errorMessage: string;
    isLoading: boolean;
    variantStyleButton: "outlined" | "contained";
    register: UseFormMethods["register"];
    error: FieldError | undefined;
    retryCode(): void;
    validateCode(): void;
}

export const ValidationCodeView = (props: IParams) => {
    const { register, validateCode, retryCode, error, variantStyleButton, isLoading, errorMessage } = props;
    const { t } = useTranslation(["portin", "common", "validation"]);

    return (
        <Grid container>
            <Grid item xs={12}>
                <TextField
                    error={Boolean(error) || Boolean(errorMessage)}
                    fullWidth
                    helperText={error?.message ?? errorMessage}
                    id="validationCode"
                    inputRef={register({
                        required: t("validation:required"),
                        validate: (value: string) =>
                            value && value.length === 6 ? undefined : t("validation:exactLengthError", { count: 6 }),
                    })}
                    label={`${t("portin:validationCode")} *`}
                    margin="dense"
                    name="validationCode"
                    type="text"
                />
            </Grid>
            <Grid className="validation-actions" container>
                <Grid className="validation-actions__message" item xs={12}>
                    <Typography color="secondary" variant="normal">
                        {t("portin:checkValidationCode")}
                    </Typography>
                </Grid>
                {isLoading && <Loader size={40} />}
                {!isLoading && (
                    <Fragment>
                        <Grid className="validation-actions__retry" item>
                            <Button color="primary" variant="outlined" onClick={retryCode}>
                                {t("common:retry")}
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                className="xtest_confirm_validation_code"
                                color="primary"
                                variant={variantStyleButton}
                                onClick={validateCode}
                            >
                                {t("common:confirm")}
                            </Button>
                        </Grid>
                    </Fragment>
                )}
            </Grid>
        </Grid>
    );
};
